import Editor from 'components/features/editor/QuillEditor'
import { debounce } from 'utils/common'
import { Form, FormInstance, Input } from 'antd'
import { useEffect, useState } from 'react'

interface IFormContentProps {
  form: FormInstance
  lang: string
  dataSource: any
}

const FormContent = ({ form, lang, dataSource }: IFormContentProps) => {
  const [content, setContent] = useState<string>()
  useEffect(() => {
    if (dataSource?.id) {
      setContent(dataSource?.description[lang])
    } else {
      setContent(' ')
    }
  }, [])

  const rteChange = debounce(function (value: any) {
    setContent(value)
  }, 10)
  return (
    <>
      <div className='form-language'>
        <Form.Item
          name={[lang, 'name']}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              whitespace: true,
              message: `please input title ${lang.toUpperCase()}`,
            },
          ]}
        >
          <Input size='large' placeholder={`Event name ${lang.toUpperCase()}`} />
        </Form.Item>

        <Form.Item
          name={[lang, 'description']}
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            {
              required: true,
              whitespace: true,
              message: `please input answer ${lang.toUpperCase()}`,
            },
          ]}
        >
          {!!content && (
            <Editor
              content={content}
              onChange={(value) => rteChange(value)}
              image={true}
              folder={'article'}
              className='editor-content'
            />
          )}
        </Form.Item>
      </div>
    </>
  )
}

export default FormContent
